(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 61256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70981);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96200);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children", "className", "onPrimaryBg"],
    _excluded2 = ["node", "children", "href"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      $onPrimaryBg = _ref.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.main : theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme,
      $onPrimaryBg = _ref2.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.mainHover : theme.colors.text;
});
var StyledReactMarkdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_markdown__WEBPACK_IMPORTED_MODULE_6__/* .ReactMarkdown */ .D)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  line-height: 1.6;\n  font-size: 1.6rem;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
});

var MarkdownText = function MarkdownText(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      onPrimaryBg = _ref4.onPrimaryBg,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref4, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledReactMarkdown, _objectSpread(_objectSpread({}, props), {}, {
    className: "markdown-text-wrapper ".concat(className),
    rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z],
    components: {
      a: function a(_ref5) {
        var node = _ref5.node,
            children = _ref5.children,
            href = _ref5.href,
            aProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref5, _excluded2);

        var isExternal = href.startsWith('http');
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: href,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledA, _objectSpread(_objectSpread({}, aProps), {}, {
            target: isExternal ? '_blank' : undefined,
            rel: isExternal ? 'noopener' : undefined,
            $onPrimaryBg: onPrimaryBg,
            children: children
          }))
        });
      }
    },
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (MarkdownText);

/***/ }),

/***/ 52816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TitleH1 */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42997);
/* harmony import */ var _atoms_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;





var GradientText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .ZP.span(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  background: ", ";\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryGradient;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  margin-bottom: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding: 0 1rem;\n    margin-bottom: ", ";\n  }\n"])), function (_ref2) {
  var $marginBottom = _ref2.$marginBottom;
  return $marginBottom ? $marginBottom : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref4) {
  var $marginBottom = _ref4.$marginBottom;
  return $marginBottom ? "calc(".concat($marginBottom, " / 2)") : 0;
});
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 3rem;\n"])));
var Description = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p */ .ZP.p(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: center;\n  margin: initial;\n  font-weight: initial;\n  line-height: 1.6;\n  font-size: 1.6rem;\n  font-weight: 500;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n  color: ", ";\n\n  max-width: 800px;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
});
var TitleH1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1 */ .ZP.h1(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  text-align: center;\n  font-size: 46px;\n  @media screen and (max-width: ", ") {\n    font-size: 3rem;\n  }\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.headingFontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
});
var StyledMarkdownContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  max-width: 800px;\n  text-align: center;\n  p {\n    font-family: Inter, sans-serif;\n    text-align: center;\n    margin: initial;\n    line-height: 1.6;\n    font-size: 1.6rem;\n    font-weight: 500;\n    color: ", ";\n    max-width: 800px;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.text;
});

var PageTitle = function PageTitle(_ref12) {
  var title = _ref12.title,
      description = _ref12.description,
      $marginBottom = _ref12.$marginBottom;

  var _split = (title || '').split('<gradient>'),
      _split2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_split, 3),
      before = _split2[0],
      gradientText = _split2[1],
      after = _split2[2];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
    $marginBottom: $marginBottom,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Inner, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TitleH1, {
        children: [before, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GradientText, {
          children: gradientText
        }), after]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMarkdownContainer, {
        style: {},
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_markdown__WEBPACK_IMPORTED_MODULE_0__["default"], {
          children: description
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);

/***/ }),

/***/ 28035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var SEO = function SEO(_ref) {
  var _openGraphImage$data;

  var propTitle = _ref.title,
      metaTitle = _ref.metaTitle,
      metaDescription = _ref.metaDescription,
      twitterCard = _ref.twitterCard,
      twitterSite = _ref.twitterSite,
      twitterCreator = _ref.twitterCreator,
      openGraphImage = _ref.openGraphImage,
      noindex = _ref.noindex,
      jsonSchema = _ref.jsonSchema;
  var title = propTitle || metaTitle;
  var ogImage = openGraphImage === null || openGraphImage === void 0 ? void 0 : (_openGraphImage$data = openGraphImage.data) === null || _openGraphImage$data === void 0 ? void 0 : _openGraphImage$data.attributes;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
        children: title
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:title",
        content: title
      }, "og:title")]
    }), metaDescription && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }, "description"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:description",
        content: metaDescription
      }, "twitter:description")]
    }), twitterCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: twitterCard
    }, "twitter:card"), twitterSite && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:site",
      content: twitterSite
    }, "twitter:site"), twitterCreator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:creator",
      content: twitterCreator
    }, "twitter:creator"), ogImage && (ogImage === null || ogImage === void 0 ? void 0 : ogImage.url) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image",
        content: ogImage.url
      }, "og:image"), ogImage.width && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:width",
        content: ogImage.width
      }, "og:image:width"), ogImage.height && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:height",
        content: ogImage.height
      }, "og:image:height"), ogImage.alternativeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:alt",
        content: ogImage.alternativeText
      }, "og:image:alt"), ogImage.mime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:type",
        content: ogImage.mime
      }, "og:image:type")]
    }), jsonSchema && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(jsonSchema)
      }
    }, "jsonSchema"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "robots",
      content: noindex ? 'noindex' : 'index follow'
    }, "robots")]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SEO);

/***/ }),

/***/ 61446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ContactPage; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19010);
/* harmony import */ var final_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95142);
/* harmony import */ var components_layout_pageTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52816);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28035);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);




var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var CalculatorCard = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __webpack_require__.e(/* import() */ 749).then(__webpack_require__.bind(__webpack_require__, 3749));

        case 2:
          return _context.abrupt("return", _context.sent.CalculatorCard);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3749)];
    }
  }
});
var CgSpinnerTwoAlt = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80471));

        case 2:
          return _context2.abrupt("return", _context2.sent.CgSpinnerTwoAlt);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80471)];
    }
  }
});
var MarkdownText = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61256));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61256)];
    }
  }
});
var Input = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(937), __webpack_require__.e(309), __webpack_require__.e(427)]).then(__webpack_require__.bind(__webpack_require__, 6427));

        case 2:
          return _context3.abrupt("return", _context3.sent.Input);

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6427)];
    }
  }
});
var StyledField = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(937), __webpack_require__.e(309), __webpack_require__.e(427)]).then(__webpack_require__.bind(__webpack_require__, 6427));

        case 2:
          return _context4.abrupt("return", _context4.sent.StyledField);

        case 3:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6427)];
    }
  }
});
var Textarea = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(937), __webpack_require__.e(309), __webpack_require__.e(427)]).then(__webpack_require__.bind(__webpack_require__, 6427));

        case 2:
          return _context5.abrupt("return", _context5.sent.Textarea);

        case 3:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6427)];
    }
  }
});
var Form = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee6() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return __webpack_require__.e(/* import() */ 889).then(__webpack_require__.bind(__webpack_require__, 66688));

        case 2:
          return _context6.abrupt("return", _context6.sent.Form);

        case 3:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(66688)];
    }
  }
});
var Field = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return __webpack_require__.e(/* import() */ 889).then(__webpack_require__.bind(__webpack_require__, 66688));

        case 2:
          return _context7.abrupt("return", _context7.sent.Field);

        case 3:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(66688)];
    }
  }
});
var SubmitButton = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].button */ .ZP.button(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(["\n  padding: 1rem 2rem;\n  background: ", ";\n  border-radius: 5px;\n  border: 0;\n  cursor: pointer;\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.secondaryGradient;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.textInverse;
});

var required = function required(value) {
  return !!value ? undefined : 'This field is required';
};

var Spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(CgSpinnerTwoAlt)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(["\n  width: 30px;\n  height: 30px;\n  animation-name: spin;\n  animation-duration: 1000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var __N_SSG = true;
function ContactPage(_ref10) {
  var seoData = _ref10.seoData,
      text = _ref10.text,
      privacyText = _ref10.privacyText;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      submitted = _useState2[0],
      setSubmitted = _useState2[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({}, seoData)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_layout_pageTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      $marginBottom: '5rem',
      title: 'Contact <gradient>SatsGoal<gradient>',
      description: text
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      maxWidth: "600px",
      marginHorizontal: "auto",
      width: "100%",
      style: {
        boxSizing: 'border-box'
      },
      paddingHorizontal: 1,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(CalculatorCard, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Form, {
          onSubmit: /*#__PURE__*/function () {
            var _ref11 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(values) {
              var _yield$axios$post, data, _err$response;

              return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      setLoading(true);
                      _context8.prev = 1;
                      _context8.next = 4;
                      return axios__WEBPACK_IMPORTED_MODULE_6___default().post('https://api.formjam.io/form/da4f18ae-2025-4264-b4d4-e17f4edf7c5b', values);

                    case 4:
                      _yield$axios$post = _context8.sent;
                      data = _yield$axios$post.data;
                      _context8.next = 13;
                      break;

                    case 8:
                      _context8.prev = 8;
                      _context8.t0 = _context8["catch"](1);
                      console.error('Error', _context8.t0);
                      setLoading(false);
                      return _context8.abrupt("return", ((_err$response = _context8.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, final_form__WEBPACK_IMPORTED_MODULE_3__/* .FORM_ERROR */ .Ck, 'Error submitting.'));

                    case 13:
                      setLoading(false);
                      setSubmitted(true);

                    case 15:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8, null, [[1, 8]]);
            }));

            return function (_x) {
              return _ref11.apply(this, arguments);
            };
          }(),
          children: function children(_ref13) {
            var handleSubmit = _ref13.handleSubmit;
            return !submitted && !loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("form", {
              onSubmit: handleSubmit,
              style: {
                width: '100%'
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                type: "hidden",
                name: "_f2NRWLP3o69c",
                children: function children(_ref14) {
                  var input = _ref14.input;
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", _objectSpread(_objectSpread({}, input), {}, {
                    value: ""
                  }));
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(atomic_layout__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                flex: true,
                flexDirection: "column",
                gapRow: 2,
                width: "100%",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                  name: "email",
                  type: "email",
                  validate: required,
                  children: function children(_ref15) {
                    var input = _ref15.input,
                        meta = _ref15.meta;
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledField, {
                      label: "Email Address",
                      error: meta.touched && meta.error,
                      style: {
                        width: '100%'
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Input, _objectSpread(_objectSpread({}, input), {}, {
                        style: {
                          border: 'none'
                        }
                      }))
                    });
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(atomic_layout__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                  flex: true,
                  gap: 2,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                    name: "firstName",
                    validate: required,
                    children: function children(_ref16) {
                      var input = _ref16.input,
                          meta = _ref16.meta;
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledField, {
                        label: "First Name",
                        error: meta.touched && meta.error,
                        style: {
                          flex: 1
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Input, _objectSpread(_objectSpread({}, input), {}, {
                          style: {
                            border: 'none'
                          }
                        }))
                      });
                    }
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                    name: "lastName",
                    validate: required,
                    children: function children(_ref17) {
                      var input = _ref17.input,
                          meta = _ref17.meta;
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledField, {
                        label: "Last Name",
                        error: meta.touched && meta.error,
                        style: {
                          flex: 1
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Input, _objectSpread(_objectSpread({}, input), {}, {
                          style: {
                            border: 'none'
                          }
                        }))
                      });
                    }
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                  name: "message",
                  validate: required,
                  children: function children(_ref18) {
                    var input = _ref18.input,
                        meta = _ref18.meta;
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledField, {
                      label: "Your Message",
                      error: meta.touched && meta.error,
                      style: {
                        width: '100%'
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Textarea, _objectSpread(_objectSpread({}, input), {}, {
                        style: {
                          border: 'none'
                        }
                      }))
                    });
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Field, {
                  name: "consentGiven",
                  type: "checkbox",
                  validate: required,
                  children: function children(_ref19) {
                    var input = _ref19.input,
                        meta = _ref19.meta;
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledField, {
                      style: {
                        width: '100%',
                        marginTop: '-20px',
                        marginBottom: '-20px'
                      },
                      error: meta.touched && meta.error,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(atomic_layout__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        gap: 1,
                        flex: true,
                        alignItems: "center",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", _objectSpread({
                          id: "consentGiven"
                        }, input)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("label", {
                          "for": "consentGiven",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(MarkdownText, {
                            children: privacyText
                          })
                        })]
                      })
                    });
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                  flex: true,
                  justifyContent: "flex-end",
                  padding: 1,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(SubmitButton, {
                    type: "submit",
                    children: "Submit Message"
                  })
                })]
              })]
            }) : !!loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Spinner, {})
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
              children: "Thanks, your enquiry has been submitted!"
            });
          }
        })
      })
    })]
  });
}

/***/ }),

/***/ 48105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(61446);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [981,200,262,774,888,179], function() { return __webpack_exec__(48105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);